import { jsPDF } from "jspdf";
// import logoOC from '../../../logo/ocean_logo2.png';
import logoOC from '../../../logo/HD.jpg';
import ContainerPart from '../../../logo/containerParts.png';
import highpoint from '../../../logo/highpoint.png';
import { toDataURL } from '../../../Functions';
import { pageShort } from '../pdfFormat';

import { ULHeadCompose, ULBodyCompose, ULTableCompose, } from './ULContent';

import { CANHeadCompose, CANBodyContentCompose, CANGuidelineCondition, } from './CargoArrivalNoticeContent';

import { CroHeadCompose, CroBodyCompose, } from './CroContent';

import { CDRHeadCompose, CDRBodyCompose } from './CDRContent'

import { CargoTransferSlipHeaDCompose, CargoTransferSlipHeadingCompose, CargoTransferSlipContentCompose, CargoTransferSlipClosingCompose, } from './CTSContent'

import { VANHeadCompose, VANBodyContentCompose, } from './VesselArrivalNoticeContent';

import { VLogoCompose, VCTSHeadingCompose, VCTSContentCompose, VCTSClosingCompose, } from './VanInClearanceContent';

import { WBTruckHeadCompose, WBTruckBodyCompose, WBTruckFootCompose, } from '../OutBoundPdf/WBTruckerContent';

export function UnloadListPdf(data) {
    var detail = data.tallysheet;
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layoutL, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Unload List',
                subject: 'UL',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            rowL = ULHeadCompose(pageShort, rowL, dataDoc, dataUrl);
            rowL = ULBodyCompose(pageShort, rowL, dataDoc, data);
            ULTableCompose(pageShort, rowL, dataDoc, detail);

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function CargoArrivalNoticePdf(data) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);

            dataDoc.setProperties({
                title: 'Cargo Arrival Notice',
                subject: 'CAN',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            data.forEach((element, i) => {
                var rowL = pageShort.margin.top;

                rowL = CANHeadCompose(pageShort, rowL, dataDoc, dataUrl);
                rowL = CANBodyContentCompose(pageShort, rowL, dataDoc, element);
                CANGuidelineCondition(pageShort, rowL, dataDoc, element);

                if ((i + 1) < data.length) {
                    dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                }
            });

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function CroPdf(data, user) {
    // console.log(data);
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);

            dataDoc.setProperties({
                title: 'Cargo Release Order',
                subject: 'CRO',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            var rowL = pageShort.margin.top;

            rowL = CroHeadCompose(pageShort, rowL, dataDoc, dataUrl);
            CroBodyCompose(pageShort, rowL, dataDoc, data, user);

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function CDRPdf(data, user) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);

            dataDoc.setProperties({
                title: 'Cargo Delivery Receipt',
                subject: 'CDR',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            var rowL = pageShort.margin.top;

            rowL = CDRHeadCompose(pageShort, rowL, dataDoc, dataUrl);
            CDRBodyCompose(pageShort, rowL, dataDoc, data, user);

            // dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function CTSPdf(selectedData, user) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
            var rowL = pageShort.margin.top;

            dataDoc.setProperties({
                title: 'Cargo Transfer Slip',
                subject: 'CTS',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(11);
            dataDoc.setFont("times", "bold");
            rowL = CargoTransferSlipHeaDCompose(pageShort, rowL, dataDoc, dataUrl);
            rowL = CargoTransferSlipHeadingCompose(pageShort, rowL, dataDoc, selectedData);
            rowL = CargoTransferSlipContentCompose(pageShort, rowL, dataDoc, selectedData);
            CargoTransferSlipClosingCompose(pageShort, rowL, dataDoc, user, selectedData);
            dataDoc.setFont("times", "normal");

            dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function CTSCDRPdf(data, user, wbTrData) {
    toDataURL(logoOC)
        .then(dataUrl => {
            toDataURL(ContainerPart)
            .then(containerURL => {
                toDataURL(highpoint)
                .then(HPURL => {
                    var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                    var rowL = pageShort.margin.top;

                    dataDoc.setProperties({
                        title: 'Cargo Transfer Slip And Cargo Delivery Receipt',
                        subject: 'CTS & CDR',
                        creator: 'OTGCI'
                    });

                    dataDoc.setFont("courier", "normal");
                    dataDoc.setFontSize(11);
                    dataDoc.setFont("times", "bold");
                    rowL = CargoTransferSlipHeaDCompose(pageShort, rowL, dataDoc, dataUrl);
                    rowL = CargoTransferSlipHeadingCompose(pageShort, rowL, dataDoc, data);
                    rowL = CargoTransferSlipContentCompose(pageShort, rowL, dataDoc, data, containerURL);
                    CargoTransferSlipClosingCompose(pageShort, rowL, dataDoc, user, data);

                    data.forEach(element => {
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        rowL = pageShort.margin.top;
                        rowL = CDRHeadCompose(pageShort, rowL, dataDoc, dataUrl);
                        CDRBodyCompose(pageShort, rowL, dataDoc, element, user);
                    });

                    dataDoc.setFont("times", "normal");

                    if(wbTrData){
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                        rowL = pageShort.margin.top;
                        dataDoc.setFontSize(10);
                        rowL = WBTruckHeadCompose(pageShort, rowL, dataDoc, wbTrData, HPURL);
                        rowL = WBTruckBodyCompose(pageShort, rowL, dataDoc, wbTrData);
                        WBTruckFootCompose(pageShort, rowL, dataDoc, wbTrData);
                    }
                    dataDoc.autoPrint();
                    window.open(dataDoc.output('bloburl'), '_blank');
                })
            })
        })
}

export function VesselArrivalNoticePdf(data) {
    toDataURL(logoOC)
        .then(dataUrl => {
            var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);

            dataDoc.setProperties({
                title: 'Vessel Arrival Notice',
                subject: 'VAN',
                creator: 'OTGCI'
            });

            dataDoc.setFont("courier", "normal");
            dataDoc.setFontSize(10);

            data.forEach((element, i) => {
                if(element && element.length > 0){
                    var rowL = pageShort.margin.top;

                    rowL = VANHeadCompose(pageShort, rowL, dataDoc, dataUrl);
                    VANBodyContentCompose(pageShort, rowL, dataDoc, element);
    
                    if ((i + 1) < data.length) {
                        dataDoc.addPage(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                    }
                }

            });
            // dataDoc.autoPrint();
            window.open(dataDoc.output('bloburl'), '_blank');

        })
}

export function VANINCLEARANCEPDF(data) {
    toDataURL(logoOC)
        .then(dataUrl => {
            toDataURL(ContainerPart)
            .then(containerURL => {
                var dataDoc = new jsPDF(pageShort.layout, pageShort.papersize.unit, pageShort.papersize.format);
                var rowL = pageShort.margin.top;

                dataDoc.setProperties({
                    title: 'Van-In Clerance',
                    subject: 'Van-In',
                    creator: 'OTGCI'
                });

                dataDoc.setFont("courier", "normal");
                dataDoc.setFontSize(11);
            
                rowL = VLogoCompose(pageShort, rowL, dataDoc, dataUrl, 'first');
                rowL = VCTSHeadingCompose(pageShort, rowL, dataDoc, data);
                rowL = VCTSContentCompose(pageShort, rowL, dataDoc, data, containerURL);
                // rowL = VCTSClosingCompose(pageShort, rowL, dataDoc, data);
                VCTSClosingCompose(pageShort, rowL, dataDoc, data);

                // rowL = VLogoCompose(pageShort, rowL, dataDoc, dataUrl, 'second');
                // rowL = VCDRBodyOneCompose(pageShort, rowL, dataDoc, data);
                // rowL = VCDRBodyTwoCompose(pageShort, rowL, dataDoc, data);
                // VCDRBodyThreeCompose(pageShort, rowL, dataDoc, data);

                // dataDoc.autoPrint();
                window.open(dataDoc.output('bloburl'), '_blank');
            })
        })
}